import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { MdSignalWifiOff } from "react-icons/md";

interface InternetStatusModalProps {
  onRetry?: () => void;
}

const InternetStatusModal: React.FC<InternetStatusModalProps> = ({
  onRetry,
}) => {
  const [isOnline, setIsOnline] = useState<boolean>(true);
  const [wasOffline, setWasOffline] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    setIsOnline(navigator.onLine);

    const goOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        window.location.reload();
      }
    };

    const goOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, [wasOffline]);

  if (isOnline) return null;

  return (
    <Modal
      show={!isOnline}
      backdrop="static"
      keyboard={false}
      centered
      className="internet-modal"
    >
      <ModalBody className="internet-modal__body">
        <div className="internet-modal__icon">
          <MdSignalWifiOff size={70} />
        </div>

        <h4 className="internet-modal__title">No Internet Connection</h4>

        <p className="internet-modal__message">
          No internet connection. Get back online to explore and redeem exciting
          benefits!
        </p>

        <button
          className="internet-modal__retry-btn"
          onClick={onRetry || (() => window.location.reload())}
        >
          Retry
        </button>
      </ModalBody>
    </Modal>
  );
};

export default InternetStatusModal;
